<template>
    <div class="container">
        <form class="form-signin" v-on:submit.prevent="resetFormSubmit">
            <h2 class="form-signin-heading">{{langForgot.reset[locale]}}</h2>
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text">
                        <font-awesome-icon style="margin: auto" icon="envelope"/>
                    </span>
                </div>
                <input type="email" class="form-control" :placeholder="langForgot.emailPlaceholder[locale]" v-model="resetForm.email" required autofocus>
            </div>
            <b-alert :variant="!!reset.errMessage ? 'danger':'success'" :show="!!reset.errMessage || !!reset.successMessage">{{reset.errMessage || reset.successMessage}}</b-alert>
            <nettipyora-button :text="langForgot.submit[locale]" :loading="reset.loading" :className="'btn-primary'" :submit="true" />
            <br /><br />
        </form>
    </div>
</template>

<script>
import NettipyoraButton from '@/components/NettipyoraButton';
import { mapState } from 'vuex';
import langForgot from '@/store/lang/forgot';

export default {
    name: "Forgot",
    components: {
        NettipyoraButton
    },
    computed: mapState({
        locale: state => state.locale,
        reset: state => state.Forgot.reset
    }),
    data() {
        return {
            langForgot,
            resetForm: {
                email: ""
            }
        }
    },
    methods: {
        resetFormSubmit()  {
            this.$store.dispatch('FORGOT_RESET_SUBMIT', this.resetForm);
        }
    }
}
</script>

